import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: './home/home.module#HomePageModule'},
  { path: 'marcaje/:id', loadChildren: './pages/marcaje/marcaje.module#MarcajePageModule', canActivate: [AuthGuardService]},
  { path: 'historico/:nombre/:id', loadChildren: './pages/historico/historico.module#HistoricoPageModule', canActivate: [AuthGuardService]},
  { path: 'cambio-tel-pass/:nombre/:tipo', loadChildren: './pages/cambio-tel-pass/cambio-tel-pass.module#CambioTelPassPageModule',canActivate: [AuthGuardService]},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
